// Education API — proxied through Arab Sanad backend.
// The College Scorecard API key never leaves the server.
import axios from "axios";
import { API } from "@/App";

export const eduApi = {
  /**
   * Search the College Scorecard directory.
   * @param {object} filters
   * @param {string} [filters.q]            free-text school name search
   * @param {string} [filters.state]        two-letter state code (e.g. "CA")
   * @param {string} [filters.city]
   * @param {"public"|"private"|"private_nonprofit"|"private_for_profit"} [filters.ownership]
   * @param {"community_college"|"university"} [filters.school_type]
   * @param {number} [filters.student_size_min]
   * @param {number} [filters.student_size_max]
   * @param {number} [filters.tuition_max]
   * @param {number} [filters.page]         zero-indexed
   * @param {number} [filters.per_page]     up to 100
   */
  async search(filters = {}) {
    const params = {};
    Object.entries(filters).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== "") params[k] = v;
    });
    const { data } = await axios.get(`${API}/edu/schools`, { params });
    return data;
  },

  async get(id) {
    const { data } = await axios.get(`${API}/edu/schools/${id}`);
    return data;
  },
};

// US States in display order for filter dropdowns.
export const US_STATES = [
  ["AL", "Alabama"],   ["AK", "Alaska"],     ["AZ", "Arizona"],   ["AR", "Arkansas"],
  ["CA", "California"],["CO", "Colorado"],   ["CT", "Connecticut"],["DE", "Delaware"],
  ["DC", "District of Columbia"],
  ["FL", "Florida"],   ["GA", "Georgia"],    ["HI", "Hawaii"],    ["ID", "Idaho"],
  ["IL", "Illinois"],  ["IN", "Indiana"],    ["IA", "Iowa"],      ["KS", "Kansas"],
  ["KY", "Kentucky"],  ["LA", "Louisiana"],  ["ME", "Maine"],     ["MD", "Maryland"],
  ["MA", "Massachusetts"],["MI", "Michigan"],["MN", "Minnesota"], ["MS", "Mississippi"],
  ["MO", "Missouri"],  ["MT", "Montana"],    ["NE", "Nebraska"],  ["NV", "Nevada"],
  ["NH", "New Hampshire"],["NJ", "New Jersey"],["NM", "New Mexico"],["NY", "New York"],
  ["NC", "North Carolina"],["ND", "North Dakota"],["OH", "Ohio"],["OK", "Oklahoma"],
  ["OR", "Oregon"],    ["PA", "Pennsylvania"],["RI", "Rhode Island"],["SC", "South Carolina"],
  ["SD", "South Dakota"],["TN", "Tennessee"],["TX", "Texas"],    ["UT", "Utah"],
  ["VT", "Vermont"],   ["VA", "Virginia"],   ["WA", "Washington"],["WV", "West Virginia"],
  ["WI", "Wisconsin"], ["WY", "Wyoming"],
  ["PR", "Puerto Rico"],
];
